import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Shbuh.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img 
              src={logo}
              alt="SHUBH HYUNDAI Logo" 
              className="footer-logo" 
            />
            <h3 className="footer-brand-name">SHUBH HYUNDAI</h3>
            <p className="footer-tagline">SALES • SERVICE • SPARES</p>
          </div>
          <div className="footer-locations">
            <h4 className="footer-title">Our Locations</h4>
            <div className="footer-location">
              <strong>Palanpur</strong>
              <p>Abu Road Highway, Near Gayatri Temple, Tirupati Rajnagar, Palanpur, Gujarat 385001</p>
            </div>
            <div className="footer-location">
              <strong>Deesa</strong>
              <p>Deesa- Palanpur Highway, Deesa 385535</p>
            </div>
            <div className="footer-location">
              <strong>Patan</strong>
              <p>Patan–Unjha Highway, Near Hansapur, Patan – 384265</p>
            </div>
          </div>
          <div className="footer-contact">
            <h4 className="footer-title">Contact Us</h4>
            <div className="footer-contact-item">
              <strong>Sales:</strong>
              <a href="tel:+917575808003">+91 75758 08003</a>
            </div>
            <div className="footer-contact-item">
              <strong>Service:</strong>
              <a href="tel:+917575808004">+91 75758 08004</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 SHUBH HYUNDAI. All rights reserved. | Authorized Hyundai Dealership</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

